import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAtedimento } from "../../../../../Context/Atendimento";
import { useUserInfor } from "../../../../../Context/User";

import { DataSnapshot, off, onValue } from "firebase/database";

import SpinnerComponent from "../../../../../Components/Loding/Spinner";

import { TransferirAtendimentoController } from "../../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import { ITransferirMensagem } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    IEquipeFirebase,
    IUsuarioFirebase,
} from "../../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { getOnlineRef } from "../../../../../Services/Config/ConfigFirebase";

interface ITransferirForm {
    equipe_transferir: number;
    usuario_transferir: number;
}
interface ITransferirPorGerencia extends ITransferirMensagem {
    ID_EQUIPE: number;
    ID_USUARIO: number;
}
interface ITransferirProps {
    setShow: (show: boolean) => void;
    transferenciaPorGestao?: ITransferirPorGerencia;
}

export default function Transferir(props: ITransferirProps) {
    const { register, handleSubmit, watch } = useForm<ITransferirForm>();
    const { equipe, chatAberto } = useAtedimento().HELP_DESK;
    const { OrgInfor, UserInfor } = useUserInfor();

    const watcher = watch();

    const [lstEquipes, setLstEquipes] = useState<Array<IEquipeFirebase>>();
    const [lstUsuarios, setLstUsuarios] = useState<Array<IUsuarioFirebase>>();
    const [snap, setSnap] = useState<DataSnapshot>();

    const idEquipeAtual =
        props.transferenciaPorGestao?.ID_EQUIPE ?? equipe.ID_EQUIPE_HELP_DESK;
    const NREquipeAtual = `+${(
        props.transferenciaPorGestao?.From || equipe.NR_TELEFONE
    ).replace(/\D/g, "")}`;
    const idUsuarioAtual =
        props.transferenciaPorGestao?.ID_USUARIO ?? UserInfor.ID_USUARIO;

    useEffect(() => {
        const equipesRef = getOnlineRef(OrgInfor.ID_ORGANIZACAO);
        onValue(equipesRef, (snap) => {
            const equipesOn: Array<IEquipeFirebase> = [];

            snap.forEach((childSnap) => {
                let usersOn = false;
                childSnap.child("USUARIOS").forEach((userSnap) => {
                    usersOn =
                        usersOn || userSnap.val().ID_USUARIO !== idUsuarioAtual;
                });
                if (usersOn && NREquipeAtual === childSnap.val().NR_TELEFONE) {
                    equipesOn.push(childSnap.val());
                }
            });
            setLstEquipes(equipesOn);
            setSnap(snap);
        });

        return function cleanup() {
            off(equipesRef);
        };
    }, [
        OrgInfor.ID_ORGANIZACAO,
        props.transferenciaPorGestao?.ID_EQUIPE,
        idUsuarioAtual,
        NREquipeAtual,
    ]);

    useEffect(() => {
        if (!isNaN(watcher.equipe_transferir)) {
            const usuarios: Array<IUsuarioFirebase> = [];
            snap?.child(`${watcher.equipe_transferir}`)
                .child("USUARIOS")
                .forEach((childSnap) => {
                    if (childSnap.val().ID_USUARIO !== idUsuarioAtual)
                        usuarios.push(childSnap.val());
                });
            setLstUsuarios(usuarios);
        } else setLstUsuarios(undefined);
    }, [
        watcher.equipe_transferir,
        snap,
        props.transferenciaPorGestao?.ID_EQUIPE,
        idUsuarioAtual,
    ]);

    function handleTransferirFormSubmit(formData: ITransferirForm) {
        if (props.transferenciaPorGestao || chatAberto) {
            TransferirAtendimentoController(
                formData.equipe_transferir,
                formData.usuario_transferir,
                {
                    From:
                        props.transferenciaPorGestao?.From ||
                        chatAberto?.NumeroAtendente ||
                        "",
                    To:
                        props.transferenciaPorGestao?.To ||
                        chatAberto?.NumeroCliente ||
                        "",
                }
            ).then(() => {
                props.setShow(false);
            });
        } else props.setShow(false);
    }

    return (
        <div>
            {lstEquipes ? (
                <form onSubmit={handleSubmit(handleTransferirFormSubmit)}>
                    <div className="form-group">
                        <label htmlFor="equipe_transferir">
                            Transferir para equipe:
                        </label>
                        <select
                            className="form-control"
                            name="equipe_transferir"
                            ref={register({
                                required:
                                    "Escolha uma equipe para transferir o atendimento",
                                valueAsNumber: true,
                            })}
                        >
                            <option></option>
                            {lstEquipes.map((equipe, index) => (
                                <option
                                    value={equipe.ID_EQUIPE}
                                    key={equipe.ID_EQUIPE}
                                >
                                    {equipe.DS_EQUIPE}
                                </option>
                            ))}
                        </select>
                    </div>
                    {!isNaN(watcher.equipe_transferir) && (
                        <div className="form-group">
                            <label htmlFor="usuario_transferir">
                                Transferir para usuário:
                            </label>
                            <select
                                className="form-control"
                                name="usuario_transferir"
                                ref={register({
                                    valueAsNumber: true,
                                })}
                            >
                                {watcher.equipe_transferir !== idEquipeAtual ? (
                                    <option value={0}>
                                        Fila de Atendimento
                                    </option>
                                ) : (
                                    <option value={-1}>
                                        Escolha o usuário para a transferência
                                    </option>
                                )}

                                {lstUsuarios &&
                                    lstUsuarios.map((usuario, index) => (
                                        <option
                                            value={usuario.ID_USUARIO}
                                            key={index}
                                        >
                                            {usuario.DS_USUARIO}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    )}

                    <button
                        className="btn btn-success col-12"
                        type="submit"
                        disabled={
                            !watcher.equipe_transferir ||
                            (watcher.equipe_transferir === idEquipeAtual &&
                                watcher.usuario_transferir === -1)
                        }
                    >
                        Transferir
                    </button>
                </form>
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
